import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';

import PLP from '../../src/views/PLP';
import Meta from '../../src/components/meta/Meta';
import { Analytics } from '../../src/components/analytics/Analytics';
import { ExperiencesProvider } from '../../src/components/experiences/Experiences';
import { StateProvider } from '../../src/context/PlpContext';

import styles from './search.module.scss';
import { parseCookies } from '../../src/utils/storage';

export { getServerSideProps } from '../../src/helpers/getServerSideProps';

const Index = ({
  meta,
  providerData,
  cookies,
  foundItLinks = null,
  ...props
}) => {
  const { query } = useRouter();
  const { brandName, heading, subHeading } = meta;

  const { type } = query;

  const plpCookies = useRef(cookies);
  const monetateId = useRef(plpCookies.current?.['mt.v']);

  useEffect(() => {
    if (!monetateId.current) {
      plpCookies.current = parseCookies(window.document.cookie);
      monetateId.current = plpCookies.current?.['mt.v'];
    }
  }, []);

  return (
    <ExperiencesProvider monetateId={monetateId} {...props}>
      <StateProvider
        cookies={cookies}
        providerData={providerData}
        foundItLinks={foundItLinks}
      >
        <Analytics page={{ type }} />

        <Meta {...meta} />

        <main
          id="main"
          tabIndex="-1"
          data-testid="component-plp"
          className={styles.primaryMain}
        >
          <PLP
            brandName={brandName}
            heading={heading}
            subHeading={subHeading}
          />
        </main>
      </StateProvider>
    </ExperiencesProvider>
  );
};

export default Index;
